<template>
  <div class="dialog_container">
    <el-dialog
      title="车辆档案详情"
      :visible="dialogShow"
      width="1288px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <el-tabs
          v-model="activeName"
          :tab-position="'left'"
          @tab-click="tabsChange"
        >
          <el-tab-pane label="车牌号码信息" name="carNumMes">
            <v-carNumMes
              :netId="dialogData.carId"
              ref="carNumMesRef"
            ></v-carNumMes>
          </el-tab-pane>
          <el-tab-pane label="业户信息" name="resident">
            <v-resident
              :netId="dialogData.carId"
              ref="residentRef"
            ></v-resident>
          </el-tab-pane>
          <el-tab-pane label="车辆配置参数" name="carConfig">
            <v-carConfig
              :netId="dialogData.carId"
              ref="carConfigRef"
            ></v-carConfig>
          </el-tab-pane>
          <el-tab-pane label="证件管理" name="papers">
            <v-papers :netId="dialogData.carId" ref="papersRef"></v-papers>
          </el-tab-pane>
          <el-tab-pane label="车辆检测和评定登记表" name="evaluate">
            <v-evaluate
              :netId="dialogData.carId"
              ref="evaluateRef"
            ></v-evaluate>
          </el-tab-pane>
          <el-tab-pane label="车辆维护和修理登记表" name="repair">
            <v-repair :netId="dialogData.carId" ref="repairRef"></v-repair>
          </el-tab-pane>
          <!-- <el-tab-pane label="车辆主要部位更换登记表" name=""
            >车辆主要部位更换登记表</el-tab-pane
          >
          <el-tab-pane label="车辆变更登记" name="">车辆变更登记</el-tab-pane> -->
          <el-tab-pane label="车辆行驶里程登记表" name="travelMil">
            <v-travelMil
              :netId="dialogData.carId"
              ref="travelMilRef"
            ></v-travelMil>
          </el-tab-pane>
          <el-tab-pane label="车辆机损事故登记表" name="carAccident">
            <v-carAccident
              :netId="dialogData.carId"
              ref="carAccidentRef"
            ></v-carAccident>
          </el-tab-pane>
          <el-tab-pane label="车辆维护计划登记表" name="maintenancePlan">
            <v-maintenancePlan
              :netId="dialogData.carId"
              ref="maintenancePlanRef"
            ></v-maintenancePlan>
          </el-tab-pane>
          <el-tab-pane label="车辆保险日期登记表" name="insuranceDate">
            <v-insuranceDate
              :netId="dialogData.carId"
              ref="insuranceDateRef"
            ></v-insuranceDate>
          </el-tab-pane>
          <!-- <el-tab-pane label="罐车容器检测记录" name=""
            >罐车容器检测记录</el-tab-pane
          > -->
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import resident from "./detail_resident.vue"; // 业户信息
import papers from "./detail_papers.vue"; //证件管理
import insuranceDate from "./detail_insuranceDate.vue"; //车辆保险日期登记表
import carNumMes from "./detail_carNumMes.vue"; // 车牌号码信息
import carAccident from "./detail_carAccident.vue"; // 车辆机损事故登记表
import evaluate from "./detail_carEvaluate.vue"; // 车辆检测和评定登记表
import repair from "./detail_carRepair.vue"; // 车辆维护和修理登记表
import maintenancePlan from "./detail_carMaintenancePlan.vue"; // 车辆维护计划登记表
import travelMil from "./detail_carTravelMil.vue"; // 车辆行驶里程登记表
import carConfig from "./detail_carConfig.vue";
export default {
  name: "",
  data() {
    return {
      activeName: "carNumMes"
    };
  },
  components: {
    "v-resident": resident,
    "v-papers": papers,
    "v-insuranceDate": insuranceDate,
    "v-carNumMes": carNumMes,
    "v-carAccident": carAccident,
    "v-evaluate": evaluate,
    "v-repair": repair,
    "v-maintenancePlan": maintenancePlan,
    "v-travelMil": travelMil,
    "v-carConfig": carConfig,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default: {},
    },
  },
  watch: {
    dialogShow(val) {
      if (val) {
        this.activeName = "carNumMes";
        this.$nextTick(() => {
          this.$refs.carNumMesRef.getList();
        });
      }
    },
  },
  created() {},
  methods: {
    tabsChange(e) {
      if (e.label == "车牌号码信息") {
        this.$refs.carNumMesRef.getList();
      } else if (e.label == "业户信息") {
        this.$refs.residentRef.getList();
      } else if (e.label == "车辆配置参数") {
        this.$refs.carConfigRef.getList();
      } else if (e.label == "证件管理") {
        // this.$refs.papersRef.getList();
      } else if (e.label == "车辆检测和评定登记表") {
        this.$refs.evaluateRef.getList();
      } else if (e.label == "车辆维护和修理登记表") {
        this.$refs.repairRef.getList();
      } else if (e.label == "车辆主要部位更换登记表") {
        // 暂无页面
      } else if (e.label == "车辆变更登记") {
        // 暂无页面
      } else if (e.label == "车辆行驶里程登记表") {
          this.$refs.travelMilRef.getList();
      } else if (e.label == "车辆机损事故登记表") {
        this.$refs.carAccidentRef.getList();
      } else if (e.label == "车辆维护计划登记表") {
        this.$refs.maintenancePlanRef.getList();
      } else if (e.label == "车辆保险日期登记表") {
        this.$refs.insuranceDateRef.getList();
      }
    },
    confirm() {
      this.$emit("update:dialogShow", false);
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/css/dialog";
/deep/.el-tabs__item {
  height: 50px;
  line-height: 50px;
}
/deep/.el-tabs__item.is-active {
  background-color: #e3e9fb;
}

/deep/.el-tabs--left .el-tabs__item.is-left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/detail/detail.vue